import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import cx from 'classnames';
import { ThemeProvider } from 'theming';
import { mergeStyles } from '../../utils/StyleUtils';
import withMemo from '../../decorators/withMemo';
import styles from './styles';
var useStyles = createUseStyles(styles);
var LayoutDefault = function LayoutDefault(props) {
  var classesProp = props.classes,
    className = props.className,
    header = props.header,
    nav = props.nav,
    title = props.title,
    content = props.content,
    footer = props.footer,
    theme = props.theme;
  var classesComp = useStyles(props);
  var classes = useMemo(function () {
    return mergeStyles(classesComp, classesProp);
  }, [classesProp, classesComp]);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(classes.container, className, (theme == null ? void 0 : theme.contentPosition) === 'middle' && classes.containerCentered)
  }, /*#__PURE__*/React.createElement(React.Fragment, null, header), /*#__PURE__*/React.createElement("main", {
    className: classes.main
  }, nav && /*#__PURE__*/React.createElement("div", {
    className: classes.nav
  }, nav), title && /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, title), content), /*#__PURE__*/React.createElement(React.Fragment, null, footer)));
};
LayoutDefault.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string),
  header: PropTypes.node.isRequired,
  nav: PropTypes.node,
  title: PropTypes.node,
  content: PropTypes.node.isRequired,
  footer: PropTypes.node.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  theme: PropTypes.object
};
LayoutDefault.defaultProps = {
  className: null,
  classes: {},
  nav: null,
  title: null,
  theme: null
};
export default withMemo()(LayoutDefault);